import React from 'react';
import { useHistory } from 'react-router';
import { Button, Grid, Header, List } from 'semantic-ui-react';
import { useAgeReadyContext } from '../AgeReadyContext/AgeReadyContext';
import { DummyPartner, DefaultMedicalAssessment } from '../Models/MedicalAssessmentData';

const ResourcesPage: React.FC = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push('/home');
  };

  // This will be removed when we add the configurable resources
  const hasOwnResources = DefaultMedicalAssessment.questions.some(
    (q) => q.answer === 'No'
  );

  const { caregiverStore, partnerStore } = useAgeReadyContext();
  const existingPartner = partnerStore.partnersByIdMap.get(caregiverStore.partnerCode || '');

  const partner = existingPartner || DummyPartner;
  return (
    <Grid textAlign='center'>
      <Header as='h1'>Resources</Header>
      <Grid.Row>
        {!hasOwnResources && <Header as='h1'>No Resources to display</Header>}
        <List divided relaxed>
          {DefaultMedicalAssessment.questions.map((question) => {
            if (question.answer === 'No') {
              const matchingResouceIndex = partner.getMatchingIndex(
                question.key
              );

              return (
                <>
                  <List.Item>
                    <List.Icon
                      name='github'
                      size='large'
                      verticalAlign='middle'
                    />
                    <List.Content>
                      <List.Header as='a'>
                        {
                          partner.resources[matchingResouceIndex]
                            .header
                        }
                      </List.Header>
                      <List.Description as='a'>
                        {
                          partner.resources[matchingResouceIndex]
                            .description
                        }
                      </List.Description>
                    </List.Content>
                  </List.Item>
                </>
              );
            } else {
              return null;
            }
          })}
        </List>
      </Grid.Row>
      <Grid.Row>
        <Button primary onClick={goToDashboard}>
          Home
        </Button>
      </Grid.Row>
    </Grid>
  );
};

export default ResourcesPage;
